import { store } from '../../../../../../Feature/Cart/code/Views/Feature/Cart/ShoppingCart/React/index.jsx';
import {
  toggleMiniCart,
  openMiniCart,
} from '../../../../../../Feature/Cart/code/Views/Feature/Cart/ShoppingCart/React/Slices/CartSlice.jsx';
import CommerceApiFetchWrapper from '/Foundation/Common/code/Utils/CommerceApiFetchWrapper';
import { setCartIdCookie } from '/Foundation/React/code/Utilities/HelperUtilities';
import { br_cartAddition } from '../../../../../Bloomreach/code/Events/BloomreachCart.js';
let isRequestInProgress = false;

export const setupButton = async () => {
  var addToCartArea = document.querySelector('.product-add-to-cart');
  var discontinuedBtn = addToCartArea?.querySelector('.discontinued-btn');
  if (addToCartArea && !discontinuedBtn && window._THULEDATA.isB2CEnabled) {
    const skus = [];
    const solution = addToCartArea.querySelector('input.product-ids-for-solution').value;
    if (solution) {
      const ids = solution.split(',');

      ids.forEach((id) => {
        skus.push(id);
      });
    } else {
      skus.push(addToCartArea.querySelector('.atc-product-erpoutdoor').value);
    }
    let productId = addToCartArea.querySelector('.atc-product-id').value;
    const data = [{ productId: productId, skuIds: skus }];

    const inventory = await CommerceApiFetchWrapper('/cart/inventory-batch', {
      method: 'POST',
      body: JSON.stringify(data),
    });

    if (inventory?.items?.length) {
      setAddToCartBtn(inventory.items[0]);
    }
  }
};

const setAddToCartBtn = (data) => {
  if (!data) return;

  if (window.adobeDataLayer?.products && window.adobeDataLayer.products[0]) {
    window.adobeDataLayer.products[0].stock_status = data.isInStock ? 'In stock' : 'Out of stock';
  }

  var addToCartArea = document.querySelector('.product-detail__buy-area .product-add-to-cart');
  if (addToCartArea) {
    //To avoid potentially getting multiple ATC btns when changing car in FA
    hideAllButtons(addToCartArea);
    let section;
    let price = document.querySelector('.atc-product-price-nocurrency').value;
    let isSellable = document.querySelector('.atc-sellabe-status').value;

    let atpDateFormatted;
    if (data.availabilityDate) {
      atpDateFormatted = new Date(data.availabilityDate).toLocaleDateString(window._THULEDATA.SitecoreLanguage, {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });
    }

    if (isSellable === 'false' || data.notBuyable || (isSellable && data.isInStock && price == 0)) {
      //Product not buyable
      section = addToCartArea.querySelector('.not-buyable-btn-section');
    } else if (isSellable && data.isInStock) {
      //Buyable product
      section = addToCartArea.querySelector('.buyable-btn-section');
      let button = addToCartArea.querySelector('.buyable-btn');
      button?.addEventListener('click', async (event) => {
        if (isRequestInProgress) return;
        const wrapper = button?.closest('.product-add-to-cart');
        const productId = wrapper?.querySelector('input.atc-product-erpoutdoor').value;
        const solution = wrapper?.querySelector('input.product-ids-for-solution').value;

        const products = [];

        if (solution) {
          const ids = solution.split(',');

          ids.forEach((id) => {
            products.push(id);
          });
        } else {
          products.push(productId);
        }
        await updateCart(products, button);
      });
    } else if (isSellable && !data.isInStock) {
      //Out of stock
      section = addToCartArea.querySelector('.out-of-stock-btn-section');
      const span = section.querySelector('.tpd-product-stock-status span');
      span.textContent = span.textContent.replaceAll(' ' + atpDateFormatted, '') + ' ' + atpDateFormatted;
    }

    //Service parts are never purchasable online, so never offer "Notify me" - show the not buyable button instead.
    const isServicePart = addToCartArea.querySelector('.atc-service-part')?.value === 'true';
    //if coming soon flag is available always show notify me no matter response from api.
    const showComingSoonFlag = window._THULEDATA?.ProductDetail?.ShowComingSoonFlag;
    if (isServicePart) {
      section = addToCartArea.querySelector('.not-buyable-btn-section');
    } else if (data.showNotifyMe || showComingSoonFlag == 'True') {
      section = document.querySelector('.notify-me-btn-section');
      const button = document.querySelector('#notifyMeButton');
      const wrapper = button.closest('.product-add-to-cart');
      //Launch date from PIM
      const launchDate = wrapper.querySelector('.atc-estimated-delivery').value;
      if (!launchDate) {
        //Use date from M3/CT
        const span = section.querySelector('.tpd-product-stock-status .estimated-delivery-time');
        span.textContent = atpDateFormatted;
      }
    }

    let favoriteButtonContainer = addToCartArea
      .closest('.pdp_ButtonContainer')
      ?.querySelector('.productFavoriteButtonContainer');
    if (favoriteButtonContainer && _THULEDATA?.enableFavorites) favoriteButtonContainer.classList.remove('d-none');

    if (disableButtonIfFitassistant()) return;

    section.classList.remove('d-none');
  }
};

const disableButtonIfFitassistant = () => {
  const productType = window._THULEDATA?.ProductDetail?.ProductType;

  // 2 = Roof Rack, 8 = Truck Rack, FitAssistantVariation.cs for reference
  if (!(
    _THULEDATA.FitAssistant?.FitAssistantVariation === 2 ||
    (_THULEDATA.FitAssistant?.FitAssistantVariation === 8 && productType?.toLowerCase() === 'dummy product')
  ))
    return false;

  const fitIndicator = document.querySelector('.fit-assistant .fit-indicator');

  return !(fitIndicator?.classList.contains('confirmed') || fitIndicator?.classList.contains('unconfirmed'));
};

export const hideAllButtons = (addToCartArea) => {
  Array.from(addToCartArea?.querySelectorAll('.atc-btn-section') ?? []).forEach((section) => {
    section.classList.add('d-none');
  });
};

export const updateCart = async (products, button) => {
  if (button.classList.contains('dbg_cart_btn')) {
    store.dispatch(toggleMiniCart(true));
    return;
  }
  isRequestInProgress = true;
  const state = store.getState().Cart;
  var lineItems = state.lineItems?.length > 0 ? state.lineItems : window._THULEDATA.cartLineItems;
  let cart;

  if (lineItems?.length > 0) {
    var existingProducts = [];
    var newProducts = [];
    products.forEach((product) => {
      const matchingProductInCart = lineItems.find((x) => x.sku === product && !x.isFreeGift);
      if (matchingProductInCart)
        existingProducts.push({
          id: matchingProductInCart.id,
          quantity: matchingProductInCart.quantity + 1,
        });
      else newProducts.push(product);
    });

    if (existingProducts.length > 0) {
      let lineItems = [];
      existingProducts.forEach((product) => {
        lineItems.push({
          Id: product.id,
          Quantity: product.quantity,
        });
      });
      const data = {
        LineItems: lineItems,
      };
      await CommerceApiFetchWrapper('/cart/update-quantity', { method: 'POST', body: JSON.stringify(data) })
        .then((data) => {
          if (newProducts.length === 0) {
            store.dispatch(toggleMiniCart(true));
          }
          br_cartAddition(data);
          window.dispatchEvent(new Event('cart-updated'));
        })
        .finally(() => {
          if (newProducts.length === 0) {
            isRequestInProgress = false;
          }
        });
    }
    if (newProducts.length) {
      const data = {
        productIds: newProducts,
        quantity: 1,
      };
      addCartLines(data, button, products);
    }
  } else {
    const data = {
      productIds: products,
      quantity: 1,
    };
    addCartLines(data, button, products);
  }

  return cart;
};

const addCartLines = async (body, button, products) => {
  let cart;
  await CommerceApiFetchWrapper('/cart/add-cart-line', { method: 'POST', body: JSON.stringify(body) })
    .then((data) => {
      let cartId = data.id;
      setCartIdCookie(cartId);
      if (button.id) {
        store.dispatch(openMiniCart(`#${button.id}`));
      } else {
        store.dispatch(toggleMiniCart(true));
      }

      if (typeof mootrack !== 'undefined') {
        const wrapper = button.closest('.product-add-to-cart');
        const productId = wrapper.querySelector('.atc-product-erpoutdoor').value;
        const productpageUrl = window.location.origin + wrapper.querySelector('.atc-product-page-url').value;
        const productPriceNoCurrency = wrapper.querySelector('.atc-product-price-nocurrency').value;
        const productName = wrapper.querySelector('.atc-product-name').value;
        const productImageUrl = wrapper.querySelector('.atc-product-image-url-webp').value;
        const productName2 = wrapper.querySelector('.atc-product-name2').value;

        var extraProps = { language: window._THULEDATA.SitecoreLanguage, itemName2: productName2 };
        mootrack(
          'trackAddToOrder',
          productId,
          productPriceNoCurrency,
          productpageUrl,
          1,
          productPriceNoCurrency,
          productName,
          productImageUrl,
          extraProps
        );
      }

      br_cartAddition(data);
      window.dispatchEvent(new Event('cart-updated'));

      cart = data;
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      isRequestInProgress = false;
    });
  return cart;
};
